<template>
  <loading v-if="isInit" :message="'初期化中...'"></loading>
  <loading v-else-if="isLoading" :message="'処理中...'"></loading>
  <template v-else>
    <div class="flex">
      <p class="information">
        この画面では「勤務情報」と「申請」を記録することができます。<br>
        「勤務情報」と「申請」セクションの内容を合わせて入力してください。<br>
        この画面から保存された勤務情報及び申請には総務修正が行われた記録が残り、承認済み扱いとなります。<br>
      </p>
    </div>

    <div class="dakoku-container">
      <h3>勤務情報（{{ dateFormat(before.dakoku_date) }}）</h3>
      <div class="work-times">
        <koyouKeiyakuTimeSelect ref="koyouKeiyakuTimeRef" :isRequiredWorkTime=false :hideSyuugyouBasyo=true :koyouKeiyakuId="koyouKeiyakuId"
          :targetDate="dateFormat(before.dakoku_date)" :koyouKeiyakuTimeId="koyouKeiyakuTimeId" :userId="before.user_id"
          @change="changeSelect">
        </koyouKeiyakuTimeSelect>
      </div>

      <div class="item-wrapper">
        <div class="form-item kinmu">
          <label>出勤</label>
          <div class="after">
            <time-picker :startTime="{ hours: 0, minutes: 0 }" v-model="after.syukkin_time"
              :error="getError(form.syuuseiData, 'syukkin_time')"></time-picker>
          </div>
          <p class="before">
            {{ before.syukkin_round_datetime ? timeFormat(before.syukkin_round_datetime) : '記録なし' }}
            <span v-if="before.syukkin_datetime">（{{ timeFormat(before.syukkin_datetime) }}）</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>退勤</label>
          <div class="after">
            <time-picker :startTime="{ hours: 0, minutes: 0 }" v-model="after.taikin_time"
              :error="getError(form.syuuseiData, 'taikin_time')"></time-picker>
          </div>
          <p class="before">
            {{ before.taikin_round_datetime ? timeFormat(before.taikin_round_datetime) : '記録なし' }}
            <span v-if="before.taikin_datetime">({{ timeFormat(before.taikin_datetime) }})</span>
          </p>
        </div>


        <div class="form-item kinmu">
          <label>休憩</label>
          <div class="after">
            <time-picker :startTime="{ hours: 0, minutes: 0 }" v-model="after.kyuukei_time"
              :error="getError(form.syuuseiData, 'kyuukei_time')"></time-picker>
          </div>
          <p class="before">
            {{ before.kyuukei_round_times ? timeTypeFormat(before.kyuukei_round_times) : '記録なし' }}
            <span v-if="before.kyuukei_times">({{ timeTypeFormat(before.kyuukei_times) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>所定労働時間</label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.syotei_work_times" :error="getError(form.syuuseiData, 'syotei_work_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.syotei_work_times ? timeTypeFormat(before.syotei_work_times) : '記録なし' }}
            <span v-if="before.syotei_work_times">({{ timeTypeFormat(before.syotei_work_times) }})
            </span>
          </p>
        </div>
      </div>

      <div class="item-wrapper">
        <div class="form-item kinmu">
          <label>遅刻</label>
          <div class="after">
            <time-picker :startTime="{ hours: 0, minutes: 0 }" v-model="after.chikoku_times"
              :error="getError(form.syuuseiData, 'chikoku_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.chikoku_times ? timeTypeFormat(before.chikoku_times) : '記録なし' }}
            <span v-if="before.chikoku_times">（{{ timeTypeFormat(before.chikoku_times) }}）</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>早退</label>
          <div class="after">
            <time-picker :startTime="{ hours: 0, minutes: 0 }" v-model="after.soutai_times"
              :error="getError(form.syuuseiData, 'soutai_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.soutai_times ? timeTypeFormat(before.soutai_times) : '記録なし' }}
            <span v-if="before.soutai_times">({{ timeTypeFormat(before.soutai_times) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>外出</label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.gaisyutsu_time" :error="getError(form.syuuseiData, 'gaisyutsu_time')"></time-picker>
          </div>
          <p class="before">
            {{ before.gaisyutsu_round_datetime ? timeFormat(before.gaisyutsu_round_datetime) : '記録なし' }}
            <span v-if="before.gaisyutsu_round_datetime">({{ timeFormat(before.gaisyutsu_round_datetime) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>戻り</label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.modori_time" :error="getError(form.syuuseiData, 'modori_time')"></time-picker>
          </div>
          <p class="before">
            {{ before.modori_round_datetime ? timeFormat(before.modori_round_datetime) : '記録なし' }}
            <span v-if="before.modori_datetime">({{ timeFormat(before.modori_round_datetime) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>控除時間</label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.koujo_times" :error="getError(form.syuuseiData, 'koujo_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.koujo_times ? timeTypeFormat(before.koujo_times) : '記録なし' }}
            <span v-if="before.koujo_times">({{ timeTypeFormat(before.koujo_times) }})</span>
          </p>
        </div>
      </div>

      <div class="item-wrapper">
        <div class="form-item kinmu">
          <label>法定内残業</label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.houteinai_zangyou_times"
              :error="getError(form.syuuseiData, 'houteinai_zangyou_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.houteinai_zangyou_times ? timeTypeFormat(before.houteinai_zangyou_times) : '記録なし' }}
            <span v-if="before.houteinai_zangyou_times">({{ timeTypeFormat(before.houteinai_zangyou_times) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>時間外 </label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.jikangai_work_times"
              :error="getError(form.syuuseiData, 'jikangai_work_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.jikangai_work_times ? timeTypeFormat(before.jikangai_work_times) : '記録なし' }}
            <span v-if="before.jikangai_work_times">({{ timeTypeFormat(before.jikangai_work_times) }})</span>
          </p>
        </div>

        <div class="form-item kinmu">
          <label>深夜割増 </label>
          <div class="after">
            <time-picker class="after" :startTime="{ hours: 0, minutes: 0 }"
              v-model="after.shinya_warimashi_times"
              :error="getError(form.syuuseiData, 'shinya_warimashi_times')"></time-picker>
          </div>
          <p class="before">
            {{ before.shinya_warimashi_times ? timeTypeFormat(before.shinya_warimashi_times) : '記録なし' }}
            <span v-if="before.shinya_warimashi_times">({{ timeTypeFormat(before.shinya_warimashi_times) }})</span>
          </p>
        </div>
      </div>
    </div>

    <div class="shinsei-container" v-if="koyouKeiyakuId">
      <h3>申請</h3>
      <div class="shinsei-wrapper">

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '時間外' }]" v-model="shinseiStatus.isJikangai"
            @change="setShiniseData(shinseiStatus.isJikangai, OptionConst.SHINSEI_CODE.JIKANGAI, before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isJikangai">
            <div class="item">
              <b class="required">時間外勤務開始日時</b>
              <time-picker v-model="shinseiStatus.jikangai.start_time" :startTime="{ minutes: 0 }"
                :error="getError(form.shinsei.jikangai, 'start_time')"></time-picker>
            </div>
            <div class="item">
              <b class="required">時間外勤務終了日時</b>
              <time-picker v-model="shinseiStatus.jikangai.end_time" :startTime="{ minutes: 0 }"
                :error="getError(form.shinsei.jikangai, 'end_time')"></time-picker>
            </div>
          </template>
        </div>

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '休憩未取得' }]" v-model="shinseiStatus.isKyuukeiJikangai"
            @change="setShiniseData(shinseiStatus.isKyuukeiJikangai, OptionConst.SHINSEI_CODE.KYUUKEI_JIKANGAI, before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isKyuukeiJikangai">
            <div class="item">
              <b class="required">作業時間</b>
              <time-picker v-model="shinseiStatus.kyuukeiJikangai.kyuukei_jikangai_times"
                :startTime="{ hours: 0, minutes: 0 }"
                :error="getError(form.shinsei.kyuukeiJikangai, 'kyuukei_jikangai_times')"></time-picker>
            </div>
          </template>
        </div>

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '日直' }]" v-model="shinseiStatus.isNittyoku"
            @change="setShiniseData(shinseiStatus.isNittyoku, OptionConst.SHINSEI_CODE.NITTYOKU, before.dakoku_date)"></input-checkbox>
        </div>

      </div>

      <div class="shinsei-wrapper">
        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '振休' }]" v-model="shinseiStatus.isFurikyuu"
            @change="setFurikyuuData(before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isFurikyuu">
            <div class="item">
              <b class="required">取得区分</b>
              <div>
                <select-box v-model="shinseiStatus.furikyuu1.furikyuutani1_type" :options="syutokuTaniOpt"
                  :error="getError(form.shinsei.furikyuu1, 'furikyuutani1_type')"></select-box>
              </div>
              <div v-if="shinseiStatus.furikyuu2.furikyuutani1_type">
                <select-box v-model="shinseiStatus.furikyuu2.furikyuutani1_type" :options="syutokuTaniOpt"
                  :error="getError(form.shinsei.furikyuu2, 'furikyuutani1_type')" :hasBlank="true"></select-box>
              </div>
            </div>
          </template>
        </div>

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '振出' }]" v-model="shinseiStatus.isFuride"
            @change="setFurideData(before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isFuride">
            <div class="item">
              <b class="required">振出取得区分</b>
              <select-box :options="furideOpt" v-model="shinseiStatus.furide.syukkin_furidetani_type"
                :error="getError(form.shinsei.furide, 'syukkin_furidetani_type')"></select-box>
            </div>
            <div class="item">
              <b class="required">出勤時間</b>
              <time-picker v-model="shinseiStatus.furide.start_time" :startTime="{ minutes: 0 }"
                :error="getError(form.shinsei.furide, 'start_time')"></time-picker>
            </div>
            <div class="item">
              <b class="required">退勤時間</b>
              <time-picker v-model="shinseiStatus.furide.end_time" :startTime="{ minutes: 0 }"
                :error="getError(form.shinsei.furide, 'end_time')"></time-picker>
            </div>
            <div class="item">
              <b class="required">休憩時間</b>
              <time-picker v-model="shinseiStatus.furide.kyuukei_time"
                :startTime="{ hours: 0, minutes: 0 }" :error="getError(shinseiStatus.furide, 'kyuukei_time')"
                :minTime="{ hours: 0, minutes: 0, seconds: 0 }"
                :maxTime="{ hours: 2, minutes: 0, seconds: 0 }"></time-picker>
            </div>
          </template>
        </div>


        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '公休' }]" v-model="shinseiStatus.isKoukyuu"
            @change="setKoukyuuData(before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isKoukyuu">
            <p v-if="getError(form.shinsei, 'koukyuu')" class="input-error"
              style="margin-top: 10px; margin-bottom: -10px;">
              {{ getError(form.shinsei, 'koukyuu') }}</p>
            <div class="item">
              <b class="required">取得区分</b>
              <div class="koukyuu-div-item">
                <select-box v-model="shinseiStatus.koukyuu.koukyuu_tani_type" :options="syutokuTaniOpt"
                  :error="getError(form.shinsei?.koukyuu, 'koukyuu_tani_type')"></select-box>
              </div>
            </div>
          </template>
        </div>

      </div>

      <div class="shinsei-wrapper">
        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '有休' }]" v-model="shinseiStatus.isYuukyuu"
            @change="setShiniseData(shinseiStatus.isYuukyuu, OptionConst.SHINSEI_CODE.YUUKYUU, before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isYuukyuu">
            <p v-if="getError(form.shinsei, 'yuukyuu')" class="input-error"
              style="margin-top: 10px; margin-bottom: -10px;">
              {{ getError(form.shinsei, 'yuukyuu') }}</p>
            <div class="item">
              <b class="required">取得区分</b>
              <div class="yuukyuu-div-item">
                <select-box v-model="shinseiStatus.yuukyuu.yuukyuu_tani_type" :options="syutokuTaniOpt"
                  :error="getError(form.shinsei?.yuukyuu, 'yuukyuu_tani_type')"></select-box>
              </div>
            </div>
            <div class="item">
              <b class="required">取得時間</b>
              <time-picker v-model="shinseiStatus.yuukyuu.yuukyuu_times"
                :startTime="{ hours: 0, minutes: 0 }" :error="getError(shinseiStatus.yuukyuu, 'yuukyuu_times')"
                :minTime="{ hours: 0, minutes: 0, seconds: 0 }"></time-picker>
              <p class="tsuujojikan-sample">※通常は {{ yuukyuuTsuujoJikan }} です。</p>
            </div>
          </template>
        </div>

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '忌引' }]" v-model="shinseiStatus.isKibiki"
            @change="setShiniseData(shinseiStatus.isKibiki, OptionConst.SHINSEI_CODE.KIBIKI, before.dakoku_date)"></input-checkbox>
          <template v-if="shinseiStatus.isKibiki">

            <div class="item">
              <b class="required">取得区分</b>
              <div class="yuukyuu-div-item">
                <select-box v-model="shinseiStatus.kibiki.kibiki_tani_type" :options="syutokuTaniOpt"
                  :error="getError(form.shinsei?.kibiki, 'kibiki_tani_type')"></select-box>
              </div>
            </div>

            <div class="item">
              <b class="required">取得時間</b>
              <time-picker v-model="shinseiStatus.kibiki.kibiki_times"
                :startTime="{ hours: 0, minutes: 0 }" :error="getError(shinseiStatus.kibiki, 'kibiki_times')"
                :minTime="{ hours: 0, minutes: 0, seconds: 0 }"></time-picker>
              <p class="tsuujojikan-sample">※通常は {{ kibikiTsuujoJikan }} です。</p>
            </div>

            <div class="item">
              <b class="title">故人氏名</b>
              <input-text type="text" v-model="shinseiStatus.kibiki.kojin_name"
                :error="getError(shinseiStatus.kibiki, 'kojin_name')"></input-text>
            </div>

            <div class="item">
              <b class="title">よみがな（故人氏名）</b>
              <input-text type="text" v-model="shinseiStatus.kibiki.kojin_kana"
                :error="getError(shinseiStatus.kibiki, 'kojin_kana')"></input-text>
            </div>

            <div class="item">
              <b class="title">続柄</b>
              <input-text type="text" v-model="shinseiStatus.kibiki.tsuzukigara"
                :error="getError(shinseiStatus.kibiki, 'tsuzukigara')"></input-text>
            </div>

            <div class="item">
              <b class="title">死去した日付</b>
              <date-picker v-model="shinseiStatus.kibiki.sikyo_date"
                :error="getError(shinseiStatus.kibiki, 'sikyo_date')"></date-picker>
            </div>
          </template>
        </div>

        <div class="form-item shinsei">
          <input-checkbox :options="[{ val: false, label: '欠勤' }]" v-model="shinseiStatus.isKekkin"
            @change="setShiniseData(shinseiStatus.isKekkin, OptionConst.SHINSEI_CODE.KEKKIN, before.dakoku_date)"></input-checkbox>
        </div>
      </div>
    </div>

    <div class="buttons button-select">
      <button type="button" class="btn success" @click="send()" :disabled="isLoadingKoyouKeiyakuTime"><i
          class="fa-solid fa-inbox"></i>保存</button>
      <button type="button" class="btn danger" @click="send(true)" :disabled="isLoadingKoyouKeiyakuTime"><i
          class="fa-solid fa-inbox"></i>打刻取消（削除）</button>
      <button type="button" class="btn cancel" @click="cancel()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>

    <div class="buttons button-select">
    </div>
  </template>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, Ref, watch } from 'vue';
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import { useDakokuSoumuSyuusei } from '@/composable/kinmu/soumu-syuusei/syuusei';
import { useInit } from '@/composable/kinmu/soumu-syuusei/init';
import { dateFormat, timeFormat } from '@/filters/common';
import dayjs from 'dayjs';
import OptionConst from '@/const/Option';
import { KoyouKeiyakuTimeAndHayabanOsobanOption } from '@/types/KoyouKeiyakuTime';
import { useForm } from "@/composable/form/form";
import { SyuuseiData } from "@/types/SoumuSyuusei";
import { DateUtil } from '@/utils/DateUtil';
import { useYuukyuu } from '@/composable/shinsei/yuukyuu/yuukyuu';
import { useKoyouKeiyakuTimeInit } from '@/composable/koyoukeiyakutime/init';
import { ConvertUtil } from "@/utils/ConvertUtil";
import { DialogService } from '@/service/DialogService';
import { KoyouKeiyakuTimeSelectEmitData, SyuugyouBasyoAndKoyouKeiyakuOption } from '@/types/SyuugyouBasyo';

export default defineComponent({
  props: {
    syuuseiData: {
      type: Object as () => SyuuseiData,
      default: null
    },
    koyouKeiyakuId: {
      type: Number as () => number | null,
      default: null
    },
    koyouKeiyakuTimeId: {
      type: Number as () => number | null,
      default: null
    },
    syuugyouBasyoId: {
      type: Number as () => number | null,
      default: null
    },
  },
  emits: {
    send: (result: boolean) => true,
    close: () => true,
  },
  setup(props, context) {
    const { getError } = useForm();
    const { isError, isLoading, update, yuukyuuTime, setJikangai, setYuukyuu, setFurikyuuFuride, setNittyoku, setKibiki, setKekkin, setKyuukeiJikangai, setKoukyuu } = useDakokuSoumuSyuusei()
    const { form, shinseiStatus, initSyuuseiData, initShinseis } = useInit(props.syuuseiData)
    const { getTimeOptionAndShiftByKoyouKeiykuId, koyouKeiyakuTimeAndHayabanOsobanOptions } = useKoyouKeiyakuTimeInit()
    const selectKoyouKeiyakuTimeOption: Ref<KoyouKeiyakuTimeAndHayabanOsobanOption | null> = ref(null)
    const isInit = ref(true)
    const koyouKeiyakuTimeRef = ref()
    const sashihikiTimes: Ref<string | null> = ref(null)
    // const yuukyuuType = ref(OptionConst.YUUKYUU_TYPE.ALL)

    const { getYuukyuuTime } = useYuukyuu()

    const before = computed(() => {
      return props.syuuseiData.before ?? initSyuuseiData().before
    })

    const after = computed(() => {
      return props.syuuseiData.after ?? initSyuuseiData().after
    })

    onMounted(async () => {
      after.value.koyou_keiyaku_id = props.koyouKeiyakuId
      after.value.mst_syuugyou_basyo_id = props.syuugyouBasyoId
      after.value.koyou_keiyaku_time_id = props.koyouKeiyakuTimeId
      await initShinseis(props.syuuseiData.after.dakoku_date, props.syuuseiData.shinseis)
      isInit.value = false
    })

    const cancel = async () => {
      const dialogResult = await DialogService.warning({
        title: 'ダイアログを閉じますか？',
        text: '保存されていない内容は破棄されます',
        showCancelButton: true,
        cancelButtonText: 'キャンセル',
        allowOutsideClick: false,
      })
      if (dialogResult.isConfirmed) {
        context.emit('close');
      }
    }

    const send = async (isDelete = false) => {
      form.value.preDakokuId = before.value.dakoku_id
      form.value.shinsei = shinseiStatus
      form.value.syuuseiData = after.value
      if (await update(form, isDelete)) {
        context.emit('send', true);
      }
    }

    const timeTypeFormat = (time: string | null, format: string = 'HH:mm') => {
      if (!time) {
        return
      }
      const date = dayjs().format('YYYY/MM/DD')
      const datetime = date + ' ' + time
      return dayjs(datetime).format(format)
    }

    const setShiniseData = (isCheck: boolean, type: number, date: string | Date | null) => {
      if (!date) {
        return
      }
      if (!isCheck) {
        return
      }
      switch (type) {
        case OptionConst.SHINSEI_CODE.YUUKYUU:
          shinseiStatus.yuukyuu = setYuukyuu(DateUtil.format(date))
          break;
        case OptionConst.SHINSEI_CODE.JIKANGAI:
          shinseiStatus.jikangai = setJikangai(DateUtil.format(date), selectKoyouKeiyakuTimeOption.value)
          break;
        case OptionConst.SHINSEI_CODE.NITTYOKU:
          shinseiStatus.nittyoku = setNittyoku(DateUtil.format(date))
          break;
        case OptionConst.SHINSEI_CODE.KIBIKI:
          shinseiStatus.kibiki = setKibiki(DateUtil.format(date))
          break;
        case OptionConst.SHINSEI_CODE.KEKKIN:
          shinseiStatus.kekkin = setKekkin(DateUtil.format(date))
          break;
        case OptionConst.SHINSEI_CODE.KYUUKEI_JIKANGAI:
          shinseiStatus.kyuukeiJikangai = setKyuukeiJikangai(DateUtil.format(date))
          break;
      }
    }


    const setFurideData = (date: string | Date | null) => {
      if (!date) {
        return
      }

      console.log("shinseiStatus.isFuride", shinseiStatus.isFuride)
      if (!shinseiStatus.isFuride) {
        return
      }

      shinseiStatus.furide = setFurikyuuFuride(DateUtil.format(date), true, after.value)
    }

    const setFurikyuuData = (date: string | Date | null) => {
      if (!date) {
        return
      }

      console.log("shinseiStatus.isFurikyuu", shinseiStatus.isFurikyuu)
      if (!shinseiStatus.isFurikyuu) {
        return
      }

      shinseiStatus.furikyuu1 = setFurikyuuFuride(DateUtil.format(date), false, after.value)
    }

    // 公休（と早番遅番）は申請のように振る舞っているが実体としては申請と異なる仕組みなので別で処理する必要がある
    const setKoukyuuData = (date: string | Date | null) => {
      if (!date) {
        return
      }

      if (!shinseiStatus.isKoukyuu) {
        return
      }

      if(!props.koyouKeiyakuId || !props.syuugyouBasyoId){ 
        return
      }
      
      shinseiStatus.koukyuu = setKoukyuu(DateUtil.format(date), props.koyouKeiyakuId, props.syuugyouBasyoId)
    }

    const changeSelect = async (emitData:KoyouKeiyakuTimeSelectEmitData) => {
      console.log("selectedKoyouKeiyakuTimeOption@changeSelect", emitData.selectedKoyouKeiyakuTimeOption)
      if (emitData.targetDate && emitData.selectedKoyouKeiyakuTimeOption) {
        selectKoyouKeiyakuTimeOption.value = emitData.selectedKoyouKeiyakuTimeOption

        after.value.koyou_keiyaku_time_id = emitData.selectedKoyouKeiyakuTimeOption.val

        // shinsei_koyou_keiyaku_timeは配列として扱われているが実際は単一のオブジェクトで構成されるはずなので、
        // アクセスする際はshinsei_koyou_keiyaku_time[0]でOK
        // どうしてこうなっているかは不明だが、PHPにおける配列とJSにおけるオブジェクトが混同した状態でインターフェースが定義されているとか？
        after.value.shinsei_koyou_keiyaku_time = [{
          shinsei_id: null,
          koyou_keiyaku_time_id: emitData.selectedKoyouKeiyakuTimeOption.val,
          target_date: emitData.selectedKoyouKeiyakuTimeOption.date,
          tsuujouTime: emitData.selectedKoyouKeiyakuTimeOption.tsuujouTime,
          isHannichi: emitData.selectedKoyouKeiyakuTimeOption.isHannichi,
          canOnlyAmKinmu: emitData.selectedKoyouKeiyakuTimeOption.canOnlyAmKinmu,
          canOnlyPmKinmu: emitData.selectedKoyouKeiyakuTimeOption.canOnlyPmKinmu,
        }]

        await getTimeOptionAndShiftByKoyouKeiykuId(props.koyouKeiyakuId, after.value.user_id, emitData.targetDate.toString())
        sashihikiTimes.value = koyouKeiyakuTimeAndHayabanOsobanOptions.value.sashihikiTime
      } else {
        after.value.koyou_keiyaku_time_id = null
        after.value.shinsei_koyou_keiyaku_time = []
      }
    }

    const isLoadingKoyouKeiyakuTime = computed(() => {
      return koyouKeiyakuTimeRef.value?.isLoading != false
    })

    const yuukyuuTsuujoJikan = computed(() => {
      return calcSampleTsuujoJikan(shinseiStatus.yuukyuu.yuukyuu_tani_type)
    })

    const kibikiTsuujoJikan = computed(() => {
      return calcSampleTsuujoJikan(shinseiStatus.kibiki.kibiki_tani_type)
    })

    const calcSampleTsuujoJikan = (shutokuTani: number | null) => {
      const koyou_keiyaku_time = after.value.shinsei_koyou_keiyaku_time;
      if (koyou_keiyaku_time == null) {
        return '00:00';
      }
      const tsuujouTime = koyou_keiyaku_time[0].tsuujouTime
      if (tsuujouTime == null || shutokuTani == null) {
        return '00:00';
      }

      const nowYMD = dayjs().format('YYYY/MM/DD')
      const fullTime = dayjs(nowYMD + ' ' + tsuujouTime)
      if(shutokuTani == OptionConst.SHINSEI_DIV.FULL_DAY){
        // 選択した取得区分タイプが1日休の場合
        return fullTime.format('HH:mm')
      } else {
        // 選択した取得区分タイプがAM休、PM休の場合
        let half = fullTime.subtract(4, 'h')
        // 4時間差し引き後の値と差引前の時間の差がマイナスになる場合
        // 3:00 - 4:00 = 23:00 等のケース
        if(fullTime.format('HH:mm') <= half.format('HH:mm')){
          return '00.00'
        }
        return half.format('HH:mm')
      }
    }

    return {
      date: dateFormat(props.syuuseiData.before.dakoku_date),
      koyouKeiyakuTimeRef,
      isInit,
      cancel,
      close,
      send,
      isLoading,
      isError,
      furideOpt: OptionConst.SHINSEI_DIV_FURIDE_OPTION,
      syutokuTaniOpt: OptionConst.SHINSEI_DIV_OPTION,
      dateFormat,
      timeFormat,
      timeTypeFormat,
      after,
      before,
      shinseiStatus,
      setShiniseData,
      OptionConst,
      changeSelect,
      yuukyuuTime,
      selectKoyouKeiyakuTimeOption,
      getError,
      form,
      isLoadingKoyouKeiyakuTime,
      getYuukyuuTime,
      sashihikiTimes,
      ConvertUtil,
      setKoukyuuData,
      setFurikyuuData,
      setFurideData,
      yuukyuuTsuujoJikan,
      kibikiTsuujoJikan
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/dialog/soumu-syuusei.scss';
</style>
